import { render } from "./Appfooter.vue?vue&type=template&id=2586ede7"
import script from "./Appfooter.vue?vue&type=script&lang=js"
export * from "./Appfooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__